import { createBrowserHistory } from 'history';

export default createBrowserHistory({
  forceRefresh: true,
});

export const browserHistory = createBrowserHistory();
